interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  id?: string;
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left', id }: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={`${isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-3xl'} mb-8 md:mb-10`}>
      {eyebrow && (
        <div
          className={`mb-3 flex items-center gap-3 ${isCenter ? 'justify-center' : ''}`}
        >
          <span className="h-px w-8 bg-primary-500" />
          <span className="font-label text-xs font-medium tracking-[0.28em] text-primary-600">
            {eyebrow}
          </span>
        </div>
      )}
      <h2 id={id} className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}